// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Amqo","tabsBox":"styles_tabsBox__2uPkt","createButton":"styles_createButton__1GMb6"};